export const baseData = {
  title: "PRODUCT SIZE"
}